export const useWidgetAlign = () => {
  const route = useRoute()

  const alignClass = () => {
    switch (route.query?.align) {
      case 'left':
        return 'justify-start'
      case 'right':
        return 'justify-end'
      default:
        return 'justify-center'
    }
  }

  return { alignClass }
}
